import { notifyService } from 'src/services/notify/NotifyService';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { IdoPrintDocumentTranslator, IdoPrintListCallbackStoreContract } from '../interfaces';

export class GetTheFilledIdoPrintDocumentQueryCallback extends Callback<Blob> {
	public constructor(
		private readonly store: IdoPrintListCallbackStoreContract,
		private readonly aggregateId: string,
		private readonly delegate: Callback<Blob>,
		private readonly t: IdoPrintDocumentTranslator
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.delegate.failureCallbackFunction(failureResponse);
		notifyService.error(this.t('ido_print_failed'));
	};

	finalizeCallbackFunction(): void {
		this.delegate.finalizeCallbackFunction();
		this.store.finishPrintingDocument(this.aggregateId);
	}

	successCallbackFunction = (successResponse: Blob, baseRecordSuccessResponse?: ResultRunTypeBaseRecord): void => {
		this.delegate.successCallbackFunction(successResponse, baseRecordSuccessResponse);
	};
}
